import React from "react";
import { Modal } from "antd";
import { ReactNode } from "react";
import { LegacyButtonType } from "antd/lib/button/button";
import "../../../assets/styles/components/confirm-modal.css";

type Props = {
  onOk: () => void;
  onCancel?: () => void;
  title: string;
  description: string | ReactNode;
  canceText: string;
  okText: string;
  icon?: ReactNode;
  extraDescription?: string | ReactNode;
  thirdDescription?: string | ReactNode;
  width?: number;
  height?: any;
  className?: string;
  okType?: LegacyButtonType;
  isCenterWithoutMenu?: boolean;
  notHaveClosable?: boolean;
};

const ConfirmModal = ({
  onOk,
  onCancel,
  title,
  description,
  canceText,
  okText,
  icon,
  width,
  height,
  className,
  okType,
  isCenterWithoutMenu,
  extraDescription,
  thirdDescription,
  notHaveClosable,
}: Props) => {

  const renderDescription = (desc: string | ReactNode) => {
    if (typeof desc === "string") {
      return (
        <div
          className="description-ccus01"
          style={
            desc.includes("\n")
              ? { whiteSpace: "pre-line" }
              : undefined
          }
        >
          {desc}
        </div>
      );
    }
    return <div className="description-ccus01">{desc}</div>;
  };

  const descriptionComponent = (
    <>
      {renderDescription(description)}
      {extraDescription && renderDescription(extraDescription)}
      {thirdDescription && renderDescription(thirdDescription)}
    </>
  );

  return Modal.confirm({
    width: width ?? 479,
    style: {
      height: height ?? 272,
      marginLeft: isCenterWithoutMenu ? 300 : 0,
    },
    centered: true,
    className:
      className ??
      "confirm__modal confirm__modal-confirm confirm__modal-purple-oke ",
    title,
    icon,
    content: descriptionComponent,
    okText,
    okType: okType ?? "danger",
    closable: !notHaveClosable,
    cancelText: canceText,
    zIndex: 9999,
    onOk: () => {
      if (onOk) onOk();
    },
    onCancel: () => {
      if (onCancel) onCancel();
    },
  });
};

export default ConfirmModal;
